import { __rest } from 'tslib';
import React from 'react';
import { css } from '@emotion/react';
import { styled } from '../../../libs/styled.es.js';

function thoundsandDelimiter(number) {
    if (!number) {
        return '0';
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
const StyledCurrency = styled.span `
  width: max-content;
  display: inline-block;
`;
const Text = styled.span(({ underline }) => css `
    text-decoration: ${underline ? 'underline' : ''};
  `);
const Currency = (_a) => {
    var { value, hideCurrency = false, space = false, underline = false } = _a, props = __rest(_a, ["value", "hideCurrency", "space", "underline"]);
    if (!value && value !== 0) {
        return React.createElement(StyledCurrency, Object.assign({}, props), "\u00A0");
    }
    return (React.createElement(StyledCurrency, Object.assign({}, props),
        thoundsandDelimiter(value),
        !hideCurrency && (React.createElement(React.Fragment, null,
            space && ' ',
            React.createElement(Text, { underline: underline }, "\u0111")))));
};

export { Currency, thoundsandDelimiter };
